export const characters = {
    en: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        },
        {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    se: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        }, {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÅÄÖ",
            value: "ÅÄÖ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    sv: [{
        name: "AB",
        value: "AB"
    },
    {
        name: "CD",
        value: "CD"
    },
    {
        name: "EF",
        value: "EF"
    },
    {
        name: "GH",
        value: "GH"
    },
    {
        name: "IJ",
        value: "IJ"
    },
    {
        name: "KL",
        value: "KL"
    },
    {
        name: "MN",
        value: "MN"
    },
    {
        name: "OP",
        value: "OP"
    },
    {
        name: "QR",
        value: "QR"
    },
    {
        name: "ST",
        value: "ST"
    },
    {
        name: "UVW",
        value: "UVW"
    }, {
        name: "XYZ",
        value: "XYZ"
    },
    {
        name: "ÅÄÖ",
        value: "ÅÄÖ"
    },
    {
        name: "0-9",
        value: "1234567890"
    }],
    de: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        },
        {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÄÖÜ",
            value: "ÄÖÜ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    fi: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        }, {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÅÄÖ",
            value: "ÅÄÖ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    nb: [
        {
            name: "AB", 
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        },
        {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÆØÅ",
            value: "ÆØÅ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    otg: {
        nb: [{
            name: "A-B",
            value: "AB"
        }, {
            name: "C-D",
            value: "CD"
        }, {
            name: "E-F",
            value: "EF"
        }, {
            name: "G-H",
            value: "GH"
        }, {
            name: "I-J",
            value: "IJ"
        }, {
            name: "K-L",
            value: "KL"
        }, {
            name: "M-N",
            value: "MN"
        }, {
            name: "O-P",
            value: "OP"
        }, {
            name: "Q-R",
            value: "QR"
        }, {
            name: "S-T",
            value: "ST"
        }, {
            name: "U-W",
            value: "UVW"
        }, {
            name: "X-Z",
            value: "XYZ"
        }, {
            name: "Æ-Å",
            value: "ÆØÅ"
        }, {
            name: "0-9",
            value: "1234567890"
        }],
        sv: [{
            name: "A-B",
            value: "AB"
        }, {
            name: "C-D",
            value: "CD"
        }, {
            name: "E-F",
            value: "EF"
        }, {
            name: "G-H",
            value: "GH"
        }, {
            name: "I-J",
            value: "IJ"
        }, {
            name: "K-L",
            value: "KL"
        }, {
            name: "M-N",
            value: "MN"
        }, {
            name: "O-P",
            value: "OP"
        }, {
            name: "Q-R",
            value: "QR"
        }, {
            name: "S-T",
            value: "ST"
        }, {
            name: "U-W",
            value: "UVW"
        }, {
            name: "X-Z",
            value: "XYZ"
        }, {
            name: "Å-Ö",
            value: "ÅÄÖ"
        }, {
            name: "0-9",
            value: "1234567890"
        }],
        en: [
            {
                name: "A-B",
                value: "AB"
            },
            {
                name: "C-D",
                value: "CD"
            },
            {
                name: "E-F",
                value: "EF"
            },
            {
                name: "G-H",
                value: "GH"
            },
            {
                name: "I-J",
                value: "IJ"
            },
            {
                name: "K-L",
                value: "KL"
            },
            {
                name: "M-N",
                value: "MN"
            },
            {
                name: "O-P",
                value: "OP"
            },
            {
                name: "Q-R",
                value: "QR"
            },
            {
                name: "S-T",
                value: "ST"
            },
            {
                name: "U-V-W",
                value: "UVW"
            },
            {
                name: "X-Y-Z",
                value: "XYZ"
            },
            {
                name: "0-9",
                value: "1234567890"
            }
        ],
        de: [
            {
                name: "A-B",
                value: "AB"
            },
            {
                name: "C-D",
                value: "CD"
            },
            {
                name: "E-F",
                value: "EF"
            },
            {
                name: "G-H",
                value: "GH"
            },
            {
                name: "I-J",
                value: "IJ"
            },
            {
                name: "K-L",
                value: "KL"
            },
            {
                name: "M-N",
                value: "MN"
            },
            {
                name: "O-P",
                value: "OP"
            },
            {
                name: "Q-R",
                value: "QR"
            },
            {
                name: "S-T",
                value: "ST"
            },
            {
                name: "U-V-W",
                value: "UVW"
            },
            {
                name: "X-Y-Z",
                value: "XYZ"
            },
            {
                name: "Ä-Ö-Ü",
                value: "ÄÖÜ"
            },
            {
                name: "0-9",
                value: "1234567890"
            }
        ],
    }
};
